module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"title.error":"พบข้อผิดพลาด","title.change":"มีการเปลี่ยนแปลง","notice.change":"ค่าเดิม {value}"}}')
  delete Component.options._Ctor
}
